/** @format */

import React from 'react';
import { observer, inject } from 'mobx-react';
import { Form } from 'semantic-ui-react';
import AdminPage from '../shared/AdminPage/AdminPage';
import AdminPageModal from '../shared/AdminPage/AdminPageModal/AdminPageModal';

@inject('UserStore')
@observer
class AdminUsers extends AdminPage {
  getStore = () => {
    const { UserStore } = this.props;
    return UserStore;
  };

  renderTableModal = () => {
    const { UserStore } = this.props;

    return (
      <AdminPageModal
        open={UserStore.edit.modal}
        errors={UserStore.edit.errors}
        toggleEditModal={UserStore.toggleEditModal}
        currentItem={UserStore.edit.currentItem}
        onSubmit={UserStore.submit}
        onDelete={UserStore.deleteItem}
        isEdit={UserStore.edit.currentItem.uid}
      >
        <Form.Group widths="equal">
          <Form.Input
            onChange={(e, input) =>
              UserStore.handleInputChange(input.value, 'email')
            }
            type="email"
            name="email"
            label="Email"
            value={UserStore.edit.currentItem.email}
          />
          <Form.Input
            onChange={(e, input) =>
              UserStore.handleInputChange(input.value, 'password')
            }
            type="password"
            name="password"
            label="Password"
            vaule={UserStore.edit.currentItem.password}
          />
        </Form.Group>
        <Form.Group widths="equal">
          <Form.Input
            onChange={(e, input) =>
              UserStore.handleInputChange(input.value, 'name')
            }
            type="text"
            name="name"
            label="Nome"
            value={UserStore.edit.currentItem.name}
          />
          <Form.Input
            onChange={(e, input) =>
              UserStore.handleInputChange(input.value, 'surname')
            }
            type="text"
            name="surname"
            label="Cognome"
            value={UserStore.edit.currentItem.surname}
          />
        </Form.Group>
        <Form.Group widths="equal">
          <Form.Input
            onChange={(e, input) =>
              UserStore.handleInputChange(input.value, 'telephone')
            }
            type="text"
            name="telephone"
            label="Telefono"
            value={UserStore.edit.currentItem.telephone}
          />
          <Form.Select
            onChange={(e, input) =>
              UserStore.handleInputChange(input.value, 'role')
            }
            name="role"
            label="Ruolo"
            options={[
              { text: 'Magazziniere', value: 'warehouse' },
              { text: 'Venditore', value: 'seller' },
            ]}
            defaultValue={UserStore.edit.currentItem.role}
          />
        </Form.Group>
        <Form.Group widths="equal">
          <Form.Checkbox
            toggle
            onChange={(e, input) =>
              UserStore.handleInputChange(input.checked, 'demolition')
            }
            name="demolition"
            label="Demolizione"
            checked={UserStore.edit.currentItem.demolition}
          />
          <Form.Checkbox
            toggle
            onChange={(e, input) =>
              UserStore.handleInputChange(input.checked, 'isExternal')
            }
            name="external"
            label="Esterno"
            checked={UserStore.edit.currentItem.isExternal}
          />
          <Form.Checkbox
            toggle
            onChange={(e, input) =>
              UserStore.handleInputChange(input.checked, 'isAdmin')
            }
            name="isAdmin"
            label="Amministratore"
            checked={UserStore.edit.currentItem.isAdmin}
          />
        </Form.Group>
      </AdminPageModal>
    );
  };
}

export default AdminUsers;
